package com.cybergstudios.rtc.world

data class Grid(val polygons: List<Polygon>) {

    fun isCleared(): Boolean {
        for (polygon in polygons) { if (polygon.enabled) return false }
        return true
    }
}
